import React from 'react'
import HeaderSkills from "./header/HeaderSkills"
import HeaderButtons from './header/HeaderButtons'
import DataPicture from './data/DataPicture'
import SkillsAside from "./aside/SkillsAside"
import SkillsBottom from "./SkillsBottom"
import LoginButtons from "./header/login/LoginButtons"


export default function Container2({skillData, section, apiData, localData, state, setSection }) {

  return (
    <>
      <div className="container yellow-bg">
        <header>
          <HeaderSkills />
          <HeaderButtons section={section} setSection={setSection} />
          <LoginButtons></LoginButtons>
        </header>
        <div className="pokemon-data-container">
          <div className="skills-subcontainer">
            <DataPicture apiData={apiData} localData={localData} state={state} section={section}></DataPicture>
            <SkillsAside apiData={apiData} localData={localData}></SkillsAside>
          </div>
            <SkillsBottom apiData={apiData} localData={localData} skillData={skillData}></SkillsBottom>
        </div>
      </div>
    </>
  )
}
